import { DxDataGridColumn } from "../models/DxDataGridColumn";
import { LastAction } from "../models/LastAction";
import { Constants } from "../constants";

export const GetLastestAction = () => {
  var localData = localStorage.getItem(Constants.LATESTACTION);
  if (localData) {
    return JSON.parse(localData) as LastAction;
  }

  return { name: "", updateDate: 1 } as LastAction;
};

export const SetLastestAction = (name: string, updateDate: number) => {
  localStorage.setItem(Constants.LATESTACTION, JSON.stringify({ name, updateDate } as LastAction));
};

export const calculationResultColumns = [
  {
    dataField: "shipTo",
    caption: "SAP Ship To",
  },
  {
    dataField: "salesOrg",
    caption: "Sales Org",
  },
  {
    dataField: "primarySalesRep",
    caption: "Primary Sales Rep",
  },
  {
    dataField: "customerName",
    caption: "Customer Name",
  },
  {
    dataField: "sapMaterialProductCode",
    caption: "SAP Material Product Code",
  },
  {
    dataField: "sapEnergySurchargeCode",
    caption: "CNTY(Surcharge)",
  },
  {
    dataField: "accessSequence",
    caption: "Access Sequence",
  },
  {
    dataField: "oldSurcharge",
    caption: "Old Surcharge Rate",
  },
  {
    dataField: "calculatedSurcharge",
    caption: "New Surcharge Rate",
  },
  {
    dataField: "currency",
    caption: "Currency",
  },
  {
    dataField: "unit",
    caption: "Unit",
  },
  {
    dataField: "uom",
    caption: "UOM",
  },
  {
    dataField: "validFrom",
    caption: "Valid From",
  },
  {
    dataField: "validTo",
    caption: "Valid To",
  },
] as DxDataGridColumn[];
